import { isoToFormatDate } from "./formatTime";

const addSearchedField = (templateMessages) => {
  templateMessages.forEach((tm) => {
    // already exists
    if (tm.searchedField) {
      return;
    }
    const texts = [isoToFormatDate(tm.updatedAt, "yyyy/MM/dd HH:mm")];

    tm.searchedField = texts.join(" ");
  });
};

export { addSearchedField };
